import {
  FETCH_AUDIT_LOGS_REQUEST,
  FETCH_AUDIT_LOGS_SUCCESS,
  FETCH_AUDIT_LOGS_FAILURE,
  SEARCH_AUDIT_LOGS_REQUEST,
  SEARCH_AUDIT_LOGS_SUCCESS,
  SEARCH_AUDIT_LOGS_FAILURE,
} from "redux/constants/AuditLogs";

const initState = {
  list: [],
  loading: false,
  error: null,
};

const AuditLogs = (state = initState, action) => {
  switch (action.type) {
    case FETCH_AUDIT_LOGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_AUDIT_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload,
        error: null,
      };

    case FETCH_AUDIT_LOGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SEARCH_AUDIT_LOGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case SEARCH_AUDIT_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload,
        error: null,
      };

    case SEARCH_AUDIT_LOGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default AuditLogs;
